import React from 'react';
import PropTypes from 'prop-types'
import _ from 'lodash';
import PresetAmountButton from './PresetAmountButton';

class PresetAmountButtons extends React.Component {
	handleClick(event, value) {
		this.props.handlePresetAmountClick(event, value);
	}

	render() {
		return (
			<div className="vx_btn-group amount-btn-group">
				{
					_.map(this.props.amounts, (amount, index) => {
						return (
							<PresetAmountButton
								key={index}
								value={amount}
								selected={amount === this.props.selectedAmount}
								symbol={this.props.symbol}
								handleAmountBtnClick={this.handleClick.bind(this)}
							/>
						)
					})
				}
			</div>
		)


	}
}

PresetAmountButtons.propTypes = {
	amounts: PropTypes.array,
	handlePresetAmountClick: PropTypes.func,
	selectedAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	symbol: PropTypes.string
};

export default PresetAmountButtons;



// WEBPACK FOOTER //
// ./components/amount/PresetAmountButtons.js